import React from 'react'
import { useNavigatorOnline } from '../hooks'
import LoadingDot from '../images/loading.svg'
import Offline from '../images/offline-text.svg'


const Loading = (props) => {
  let { className = '' } = props
  const { isOnline } = useNavigatorOnline()
  className += " loading__dimmer"
  return (
    <div className={className}>
      { isOnline ? <LoadingDot /> : <Offline/> }
    </div>
  )
}

export default Loading
